import { SquadType, TeamLeadPermissionRole } from '@scale/shared/types/expertManagement';

export const POD_SPECIFIC_ROLES = [
  TeamLeadPermissionRole.PodTypeAccess,
  TeamLeadPermissionRole.PodTypeCommunityManager,
];

export const GLOBAL_ROLES = [
  TeamLeadPermissionRole.SuperAdmin,
  TeamLeadPermissionRole.GlobalCommunityManager,
];

export const CAN_PERFORM_ACTIONS_ROLES = [
  TeamLeadPermissionRole.PodTypeCommunityManager,
  TeamLeadPermissionRole.SuperAdmin,
  TeamLeadPermissionRole.GlobalCommunityManager,
];

export const WORKER_MANAGER = 'Team Lead Dashboard';

export const AUTO_HIDEABLE_COLUMNS = [
  'gqaScore',
  'speedAuditAverage',
  'qmsScore',
  'gqaPdr',
  'speedAuditPdr',
  'gqaAndSpeedAuditScore',
  'averageBmAccuracy',
  'averageSpeedZScore',
  'slackJoinPercentage',
  'fractalGuardianScore',
  'averageFractalGuardian',
];

export const SQUAD_TYPE_TO_NAME_MAP: Record<SquadType, string> = {
  [SquadType.TeamLeadCoordinator]: 'Team Lead Coordinator',
  [SquadType.Squad]: 'Squad',
  [SquadType.Community]: 'Community',
  [SquadType.CommunitySubSquad]: 'Sub Squad',
};
